import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import MainImageForm from '../../common/image/MainImageForm';

function ProjectPanel({ isOpen, onClose, project, loading, onUpdate, onCreate }) {
  const [title, setTitle] = useState('');
  const [placeName, setPlaceName] = useState('');
  const [sponsor, setSponsor] = useState('');
  const [isHighlight, setIsHighlight] = useState(true);
  const [year, setYear] = useState(2026);
  const [mainImage, setMainImage] = useState(undefined);

  const [description, setDescription] = useState('');
  const [surface, setSurface] = useState(0);
  const [cost, setCost] = useState(0);
  const [team, setTeam] = useState('');
  const [certifications, setCertifications] = useState('');

  useEffect(() => {
    if (project) {
      setTitle(project.title);
      setYear(project.year);
      setIsHighlight(project.is_highlight);
      setDescription(project.description);
      setSurface(project.surface);
      setCost(project.cost);
      setTeam(project.team);
      setCertifications(project.certifications);
      setMainImage(project.main_image);
      setPlaceName(project.place_name);
      setSponsor(project.sponsor);
    } else {
      setTitle('');
      setYear(2026);
      setIsHighlight(false);
      setDescription('');
      setMainImage(undefined);
      setSurface(0);
      setCost(0);
      setPlaceName('');
      setTeam('');
      setCertifications('');
      setSponsor('');
    }
  }, [project, isOpen]);

  const handleValidate = () => {
    const projectPayload = {
      title,
      year,
      is_highlight: isHighlight,
      description,
      place_name: placeName,
      sponsor: sponsor,
      surface: surface,
      cost: cost,
      team: team,
      certifications: certifications,
      main_image: mainImage?.id
    };
    project ? onUpdate(projectPayload) : onCreate(projectPayload);
  };

  const formIsValid = () => {
    return title && mainImage && year && placeName && sponsor;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${project ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${project ? 'Modifier' : 'Ajouter'} un projet`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper !pb-60">
          <FormInput label={'Titre du projet'} required isValid={title.length}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre du projet"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>

          <FormInput label={'Localisation'} required isValid={placeName}>
            <InputText
              id="place_name"
              value={placeName}
              maxLength={300}
              placeholder="Veuillez saisir le nom de la localisation"
              onChange={(e) => setPlaceName(e.target.value)}
            />
          </FormInput>

          <FormInput label={'Commanditaire'} required isValid={sponsor}>
            <InputText
              id="sponsor"
              value={sponsor}
              maxLength={300}
              placeholder="Veuillez saisir le nom du commanditaire"
              onChange={(e) => setSponsor(e.target.value)}
            />
          </FormInput>

          <FormInput label={'Année'} required isValid={year}>
            <InputNumber
              id="year"
              value={year}
              placeholder="Veuillez saisir l'année"
              onChange={(e) => setYear(e.value)}
              locale="fr"
            />
          </FormInput>

          <MainImageForm mainImage={mainImage} setMainImage={setMainImage} />

          <FormInput
            label={`${isHighlight ? 'Ce projet est mis en avant' : "Ce projet n'est pas mis en avant"}`}>
            <InputSwitch checked={isHighlight} onChange={(e) => setIsHighlight(e.value)} />
          </FormInput>

          <div className={`flex flex-col gap-5 ${!isHighlight && 'opacity-30'} `}>
            <FormInput label={'Description'}>
              <RichTextEditor
                value={description}
                onChange={(value) => {
                  setDescription(value);
                }}
                readOnly={!isHighlight}
              />
            </FormInput>

            <FormInput label={'Surface en m²'}>
              <InputNumber
                id="surface"
                value={surface}
                placeholder="Veuillez saisir la surface"
                onChange={(e) => setSurface(e.value)}
                locale="fr"
              />
            </FormInput>

            <FormInput label={'Budget'}>
              <InputNumber
                id="cost"
                value={cost}
                placeholder="Veuillez saisir le budget"
                onChange={(e) => setCost(e.value)}
                locale="fr"
              />
            </FormInput>

            <FormInput label={'Equipe'}>
              <InputText
                id="team"
                value={team}
                maxLength={400}
                placeholder="Veuillez saisir le nom de l'équipe"
                onChange={(e) => setTeam(e.target.value)}
              />
            </FormInput>

            <FormInput label={'Certifications'}>
              <InputText
                id="certifications"
                value={certifications}
                maxLength={400}
                placeholder="Veuillez saisir les certifications"
                onChange={(e) => setCertifications(e.target.value)}
              />
            </FormInput>
          </div>
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default ProjectPanel;
